// Centralised UI copy for the automation underway popup. Follows
// the project's `[feature].strings.ts` convention.

const candidateNounish = (n: number) => (n === 1 ? 'candidate' : 'candidates');

export const UNDERWAY_POPUP_STRINGS = {
  header: {
    titleSingle: 'Activity underway..',
    titlePlural: (n: number) => `${n} Activities underway..`,
    minimizeAriaLabel: 'Minimize',
    expandAriaLabel: 'Expand',
    closeAriaLabel: 'Close',
  },
  item: {
    pendingPrefix: (label: string) => `${label} starting soon...`,
    pausedPrefix: (label: string) => `${label} paused`,
    runningPrefix: (label: string) => `${label} in progress...`,
    completedPrefix: (label: string) => `${label} sent`,
    failedPrefix: (label: string) => `${label} failed`,
    cancelledPrefix: (label: string) => `${label} stopped`,
    // Delayed first step: the automation is triggered but runs after a delay,
    // so it reads "scheduled" (not "sent") + a "Sends in X" line.
    scheduledPendingPrefix: (label: string) => `${label} scheduled`,
    scheduledRunningPrefix: (label: string) => `Scheduling ${label}...`,
    scheduledCompletedPrefix: (label: string) => `${label} scheduled`,
    sendsIn: (duration: string) => `Sends in ${duration}`,
    hoverToPause: 'Hover to pause',
    stop: 'Stop',
    retry: 'Retry',
    expand: 'Show details',
    collapse: 'Hide details',
    // The row's description sentence is kind-specific and pill-rich, so it's
    // built in `UnderwayItemDescription` / `activityCopy`, not as a string here.
  },
  stopConfirm: {
    title: 'Stop automation for this candidate?',
    // Single-candidate copy — references the specific candidate +
    // target stage so the user can confirm they're stopping the
    // right thing.
    bodySingle: (candidateName: string, stageName: string) =>
      `This will stop all automation for ${candidateName} in the ${stageName} stage. Are you sure?`,
    // Bulk copy — no single candidate to name, so fall back to a
    // count + stage phrasing. The "still be moved" caveat stays
    // here because bulk Stop only halts the automation, not the
    // stage move itself.
    bodyBulk: (count: number, stageName: string) =>
      `This will stop all automation for ${count} ${candidateNounish(count)} in the ${stageName} stage. They will still be moved to the new stage. Are you sure?`,
    cancel: 'Cancel',
    stop: 'Stop automation',
  },
  toasts: {
    triggerFailed: 'Automation could not be started. Please retry.',
    cancelFailed: 'Could not stop the automation. Please try again.',
    partiallyStopped:
      'Some automations had already started and could not be stopped.',
  },
  candidatesModal: {
    header: (label: string, stageName: string) =>
      `Sending ${label} in the ${stageName} stage`,
    columns: {
      candidate: 'Name',
      job: 'Job',
      stage: 'Stage',
    },
    close: 'Close',
  },
} as const;
